/**
 * @author Zilong Wang <wangzilong@manjuu.com>
 * @date 2024/1/22 18:54
 * @Last Modified by: Zilong Wang <wangzilong@manjuu.com>
 * @Last Modified time: 2022/7/22 18:54
 */

import md5 from 'js-md5';
import { OProps, parseQuery } from '@/libs';

type signType = (
  url: string,
  options?: OProps,
  testRandom?: number
) => {
  sign: string;
  datetime: number;
};

/**
 * 签名机制
 * http://yapi.manjuu.cn/project/65/interface/api/982
 * */
export const sign: signType = (url, options, testRandom) => {
  const datetime = Math.ceil(testRandom || Date.now());
  if (options) {
    const method = options.method.toLowerCase();
    const data = options.data || {};

    let params: Record<string, any> = {};
    let content = '';

    if (method.toLowerCase() === 'get') {
      params = { ...(parseQuery(url.split('?')[1]) || {}) };
      // 去掉undefined
      const filterData = JSON.parse(JSON.stringify(params));

      // 将key排序
      const sortByAscii = Object.keys(filterData).sort();

      // 重新拼串
      const result = sortByAscii.reduce((previousValue, currentValue) => {
        if (typeof filterData[currentValue] === 'object') {
          return (
            previousValue +
            `${currentValue}=${JSON.stringify(filterData[currentValue])}&`
          );
        }
        return previousValue + `${currentValue}=${filterData[currentValue]}&`;
      }, '');
      content = `${result.substring(0, result.lastIndexOf('&'))}`;
    }

    if (method.toLowerCase() === 'post') {
      content = JSON.stringify({ ...data });
    }
    return {
      sign: md5(`${datetime}${content}`),
      datetime,
    };
  }

  return {
    sign: md5(`${datetime}`),
    datetime,
  };
};
